import { api } from 'common';

import { ServiceReviewFormFields } from './FormFields';
import { ServiceReviewDocumentationMarkdown } from './documentation';
import { getDefaultServiceReviewConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const serviceReviewConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'payorCommunication',
  defaultConfig: {
    transactionType: 'Authorization',
    ...getDefaultServiceReviewConfig(),
  },
  configFields: {
    schema: api.FlowDefinition.ServiceReviewBlockConfigSchema,
    FormFields: ServiceReviewFormFields,
  },
  documentationMarkdown: ServiceReviewDocumentationMarkdown,
};
